import styled from 'styled-components';
export var Container = styled.div.withConfig({
  displayName: "elements__Container",
  componentId: "sc-1fvmaq6-0"
})(["&:not(:last-child){margin-right:", ";}"], function (_ref) {
  var numberOfMonthsToDisplay = _ref.numberOfMonthsToDisplay;
  return numberOfMonthsToDisplay === 2 ? '2.4rem' : 0;
});